import { GestorGrupo } from "../../models/gestor_grupo";
import { IGetGestoresUseCase } from "../../../presentation/useCases/read/get_gestores_use_case";
import { IAdministracaoRepository } from "../../repositories/administracao_repository";

/**
 * IGetGestoresUseCase
 */

export class GetGestoresUseCase implements IGetGestoresUseCase {
  constructor(
    private readonly repository: IAdministracaoRepository,
  ) { }

  async getGestores(): Promise<GestorGrupo[]> {
    return await this.repository.getGestores();
  }
}